import { getSites } from "..";

// Sidebar 렌더링 시 동작.
export function SidebarLoader() {
  const sites = getSites();
  return { sites };
}
